import { useNavigate } from "react-router-dom"
import { QueryNotFoundPanel } from "@cmp/loaders/queryStatePanel"

// Catch-all for unknown routes: an honest "page not found" instead of a
// silent redirect to the first tab.
export function PageNotFound() {
  const navigate = useNavigate()
  return (
    <QueryNotFoundPanel
      title="Page not found"
      description="This page doesn't exist or you don't have access to it."
      backLabel="Go to home"
      onBack={() => navigate("/")}
    />
  )
}
